import { createSelector } from 'reselect'

import { selectState } from './selectState'

export const selectJbpSettingsBusinessUnitOptions = createSelector(
  [selectState],
  (state) => state.data.stBusinessUnits
)
